export enum CompanyType {
  SOLE_PROP,
  PARTNERSHIP,
  COMPANY,
  CLOSE_CORP,
  NPO,
  TRUST,
}

export type Business = {
  companyType?: CompanyType;
  estimatedAmount?: number;
  processAmountToggle?: boolean;
  registeredName?: string;
  diffNameToggle?: boolean;
  companyName?: string;
  companyRegNumber?: string;
  industry?: string;
  natureOfBusiness?: string;
  consentToggle?: boolean;
  dateOfRegistration?: Date;
  mcc?: string;
  sic?: string;
  businessWebsiteURL?: string;
  turnOver?: boolean;
};
